// 页面级文案
export default {
  common: {
    home: '首页',
    category: '分类',
    tool: '工具',
    toolCountUnit: '个工具',
    noDescription: '暂无描述'
  },
  home: {
    docTitle: 'IEasyTool - 在线小工具',
    metaDescription: 'IEasyTool 在线小工具，免费实用的在线工具箱，涵盖文本处理、编码解码、作图设计、开发调试、文档转换、计算助手等上百款工具，即开即用。',
    metaKeywords: '在线工具,JSON格式化,Base64编码,二维码生成,图片压缩,流程图,思维导图,房贷计算器,MD5加密,时间戳转换',
    badge: '即开即用 · 完全免费',
    title: '在线小工具',
    desc: '即开即用的在线工具箱，涵盖文本处理、编码解码、作图设计、开发调试、文档转换、计算助手等 {count} 款实用工具',
    statTools: '在线工具',
    statCategories: '工具分类',
    statFree: '免费使用',
    sectionCategoryTitle: '工具分类',
    sectionCategorySub: '按类别浏览你需要的工具',
    collapse: '收起',
    showAll: '查看全部 {count} 个分类',
    sectionHotTitle: '热门工具',
    sectionHotSub: '最受欢迎的在线小工具',
    sectionRecentTitle: '最近更新',
    sectionRecentSub: '最新上线的工具'
  },
  category: {
    defaultDesc: '探索该分类下的所有工具',
    countUnit: '个工具',
    empty: '该分类下暂无工具',
    docTitleSuffix: ' - IEasyTool 在线工具'
  },
  search: {
    resultTitle: '搜索结果：{keyword}',
    resultCount: '共 {total} 个工具',
    empty: '未找到相关工具',
    emptyHintPrefix: '试试其他关键词，或浏览 ',
    emptyHintLink: '首页',
    placeholder: '搜索工具...'
  },
  favorites: {
    title: '我的收藏',
    count: '共 {count} 个工具',
    emptyTitle: '还没有收藏任何工具',
    emptyDesc: '浏览工具时点击收藏按钮即可添加到此处',
    discover: '去发现工具'
  },
  detail: {
    useCount: '{count} 次使用',
    favCount: '{count} 收藏',
    fav: '收藏',
    faved: '已收藏',
    usage: '使用说明',
    docTitleSuffix: ' - 在线工具'
  },
  card: {
    fav: '收藏',
    unfav: '取消收藏'
  },
  contact: {
    title: '联系我们',
    subtitle: '有任何问题或合作意向，欢迎通过下方表单联系我们，我们会尽快回复',
    typeAd: '广告合作',
    typeTool: '工具问题',
    typeCooperation: '开发合作',
    typeOther: '其他',
    phName: '您的姓名',
    phEmail: '邮箱地址',
    phContent: '请详细描述您的问题或合作意向...',
    submit: '发送消息',
    ruleName: '请输入姓名',
    ruleEmail: '请输入邮箱',
    ruleEmailInvalid: '邮箱格式不正确',
    ruleContent: '请输入内容',
    submitSuccess: '提交成功，我们会尽快处理',
    submitFail: '提交失败，请稍后重试'
  },
  terms: {
    body: `<h1>服务协议</h1>
<p class="update">最后更新日期：2026 年 6 月 2 日</p>
<h2>1. 服务说明</h2>
<p>小工具（以下简称"本站"）是一个在线工具箱，提供 JSON 格式化、编码转换、图片处理、文档转换等工具服务。所有工具均为免费使用，无需注册。</p>
<h2>2. 用户责任</h2>
<p>用户在使用本站工具时，应遵守中华人民共和国法律法规。严禁利用本站工具从事任何违法犯罪活动，包括但不限于：</p>
<ul>
<li>入侵他人网络或系统</li>
<li>传播恶意代码或病毒</li>
<li>侵犯他人知识产权或隐私权</li>
<li>从事欺诈、赌博等非法活动</li>
</ul>
<h2>3. 免责声明</h2>
<p>本站工具按"现状"提供，不提供任何明示或暗示的保证。本站不对工具的计算结果准确性、服务可用性做任何担保。用户因使用本站工具产生的任何损失，本站不承担责任。</p>
<h2>4. 服务变更</h2>
<p>本站保留随时修改或终止服务的权利，无需事先通知用户。</p>
<h2>5. 知识产权</h2>
<p>本站的代码、设计、内容等知识产权归本站所有。未经许可，禁止复制、镜像或商业使用。</p>
<h2>6. 联系我们</h2>
<p>如有任何疑问，请联系：y15755141030@163.com</p>`
  },
  privacy: {
    body: `<h1>隐私政策</h1>
<p class="update">最后更新日期：2026 年 6 月 2 日</p>
<h2>1. 信息收集</h2>
<p>本站为静态工具站点，不要求用户注册或登录。我们仅会收集以下必要信息：</p>
<ul>
<li><strong>使用日志</strong>：为统计工具使用情况，我们会记录工具使用日志（工具 ID、访问时间、匿名会话标识），不包含个人身份信息。</li>
<li><strong>广告点击日志</strong>：若您点击页面广告，我们会记录点击事件（广告 ID、页面类型、时间、IP 地址），用于广告效果统计。</li>
</ul>
<h2>2. 信息使用</h2>
<p>收集的信息仅用于：</p>
<ul>
<li>统计分析工具使用情况，优化服务质量</li>
<li>广告效果评估</li>
</ul>
<p>我们不会将信息用于任何其他目的，也不会与第三方共享。</p>
<h2>3. Cookie 和本地存储</h2>
<p>本站使用浏览器 localStorage 存储您的收藏列表，此数据仅保存在您的本地设备中，不会上传到服务器。您可以在浏览器设置中清除这些数据。</p>
<h2>4. 第三方服务</h2>
<p>本站集成了以下第三方服务：</p>
<ul>
<li><strong>IP 归属地查询</strong>：调用 ipapi.co 或 ip-api.com 接口查询 IP 归属地，该请求会发送您的输入到第三方服务器。</li>
<li><strong>DNS 查询</strong>：调用 Google DNS-over-HTTPS 接口，该请求会发送域名到 Google 服务器。</li>
</ul>
<p>请参阅相应第三方的隐私政策了解更多信息。</p>
<h2>5. 信息安全</h2>
<p>本站不存储任何用户上传的文件（文档转换、图片处理等功能均在浏览器本地完成）。我们采取合理措施保护服务器日志安全，但无法保证绝对安全。</p>
<h2>6. 联系我们</h2>
<p>如有隐私相关问题，请联系：y15755141030@163.com</p>`
  }
}
